import { useRef, cloneElement, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import type { FC, ReactElement } from 'react';

interface ScrollRestorationProps {
  children: ReactElement;
}

export const ScrollRestoration: FC<ScrollRestorationProps> = <
  Element extends HTMLElement,
>({
  children,
}: ScrollRestorationProps) => {
  const contentElement = useRef<Element>(null);
  const { pathname } = useLocation();

  useEffect(() => {
    contentElement.current?.scrollTo(0, 0);
  }, [pathname]);

  return cloneElement(children, { ref: contentElement });
};
